import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowLeft16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_261)'>
      <path
        d='M0.939491 8.00006L6.61268 2.32687L7.67334 3.38753L3.81084 7.25003L15 7.25003L15 8.75003L3.81078 8.75003L7.67334 12.6126L6.61268 13.6732L0.939491 8.00006Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_261'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='matrix(4.37114e-08 1 1 -4.37114e-08 0 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

ArrowLeft16.displayName = 'ArrowLeft16';
export default ArrowLeft16;
